import { render, staticRenderFns } from "./control-border-color.vue?vue&type=template&id=132fa7d7&"
import script from "./control-border-color.vue?vue&type=script&lang=js&"
export * from "./control-border-color.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports